<template>
  <el-row style="margin-bottom: 10px;margin-top: -10px" v-loading.fullscreen.lock="fullscreenLoading">
    <el-card class="box-card" style="margin-bottom: 5px">
      <el-row>
        <el-select v-model="setForm.configLab" placeholder="请选择模板" @change="selConfigLab">
          <el-option
              v-for="item in configOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <el-button type="primary" @click="post_setScript()" style="margin-left: 20px">保存设置</el-button>
      </el-row>

      <el-form ref="form_script" :model="setForm" label-width="80px">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick" style="margin-top: 10px">
          <el-tab-pane label="脚本设置" name="tab_main">
            <el-card class="box-card" style="margin-bottom: 15px;">
  <!--          <el-form style="margin-top: -1px;margin-left: -10px" :rules="rules" ref="mainForm" :model="mainForm" label-width="80px" size="mini">-->

              <el-col :span="24"  style="margin-top: -10px">
                <el-form-item label="手机类型:">
                  <el-radio-group v-model="setForm.phoneType">
                    <el-radio label="云机"></el-radio>
                    <el-radio label="小米6"></el-radio>
                  </el-radio-group>
<!--                  <el-tag type="success" style="margin-left: 20px;"></el-tag>-->
                </el-form-item>
              </el-col>
              <el-col :span="24" style="margin-top: -20px">
                <el-form-item label="账号环境:">
                  <el-radio-group v-model="setForm.loginType">
                    <el-radio label="无"></el-radio>
                    <el-radio label="VS助手"></el-radio>
                    <el-radio label="分身"></el-radio>
                  </el-radio-group>
<!--                  <el-tag type="info" style="margin-left: 20px;">切换QQ账号,QQ登录类型</el-tag>-->
                </el-form-item>
              </el-col>
              <el-col :span="24"  style="margin-top: -20px">
                <el-form-item label="执行任务:" prop="task" style="margin-bottom: 5px;">
                  <el-select v-model="setForm.task" multiple placeholder="请选择" @change="selTask" style="width: 100%">
                    <el-option
                        v-for="item in taskList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                  </el-select>

                </el-form-item>

              </el-col>

              <el-col :span="24"  style="margin-top: 0px">
                <el-form-item label="数据编号:" prop="useData" style="margin-bottom: 3px;width: 350px">
                  <el-input v-model="setForm.useData" placeholder="使用导入通讯录的编号" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="加人类型" prop="addType" style="margin-bottom: 5px;margin-left: 0px">
                  <el-checkbox v-model="setForm.addType_tele" >通讯录</el-checkbox>
                  <el-checkbox v-model="setForm.addType_search" >搜索</el-checkbox>
                </el-form-item>
              </el-col>
            </el-card>
            <el-card class="box-card" style="margin-bottom: 15px;margin-top: 5px" v-show="show_fs">

<!--              <el-col :span="24" style="margin-bottom: 5px;">-->
<!--                <el-form-item label="开始分身" prop="fs_idxS" style="margin-bottom: 5px;width: 30%">-->
<!--                  <el-input v-model="setForm.fs_idxS"></el-input>-->
<!--                </el-form-item>-->
<!--              </el-col>-->
<!--              <el-col :span="24" style="margin-bottom: 5px;">-->
<!--                <el-form-item label="结束分身" prop="fs_idxS" style="margin-bottom: 5px;width: 30%">-->
<!--                  <el-input v-model="setForm.fs_idxE"></el-input>-->
<!--                </el-form-item>-->
<!--              </el-col>-->
              <el-form-item label="开始分身" prop="fs_idxS" style="margin-left: 0px; margin-bottom: 5px;width: 2200px">
                <el-select v-model="setForm.fs_idxS" placeholder="开始序号" >
                  <el-option
                      v-for="item in fs_list"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="结束分身" prop="fs_idxE" style="margin-left: 0px; margin-bottom: 5px;width: 2200px">
                <el-select v-model="setForm.fs_idxE" placeholder="结束序号" >
                  <el-option
                      v-for="item in fs_list2"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-card>

            <el-card class="box-card" style="margin-bottom: 15px;margin-top: 15px" v-show="show_vs">
              <div>
                <el-col :span="24" style="margin-bottom: 5px">
                  <el-checkbox v-model="setForm.vs_hjRest">VS从环境1执行</el-checkbox>
                </el-col>
                <el-col :span="24" style="margin-bottom: 5px">
                  <el-checkbox v-model="setForm.vs_airSwift">VS切换环境后飞行模式</el-checkbox>
                </el-col>
                <el-col :span="24" style="margin-bottom: 5px">
                  <el-checkbox v-model="setForm.vs_updateHJerr">不更新异常环境包</el-checkbox>
                </el-col>
                <el-col :span="24" style="margin-bottom: 5px">
                  <el-checkbox v-model="setForm.vs_ignoreErrorHJ">不登录异常环境包</el-checkbox>
                </el-col>
                <el-col :span="24" style="margin-bottom: 5px;">
                  <el-checkbox v-model="setForm.vs_delHJ">启动时删除异常包</el-checkbox>
                </el-col>
                <el-col :span="24" style="margin-bottom: 5px">
                  <el-checkbox v-model="setForm.vs_updateHJ">切换账号更新环境包</el-checkbox>
                </el-col>
                <el-col :span="24" style="margin-bottom: 5px;">
                  <label><el-checkbox v-model="setForm.vs_findLab">寻找环境:已入群</el-checkbox></label>
                </el-col>
              </div>

              <el-col style="margin-bottom: 10px;">
<!--                <el-tag type="info">不登录异常的环境: 如果环境包出现账户错误,异常,将不会使用</el-tag>-->
<!--                <el-tag type="info">启动时清理异常的包: 每次启动前清理删除异常的环境包</el-tag>-->
<!--                <el-tag type="success">按实际环境数执行: 机器内有多少环境就跑多少个,将会忽略设置的环境数量</el-tag>-->
              </el-col>
                </el-card>

            <el-card class="box-card" style="margin-bottom: 15px;margin-top: -5px" v-show="show_group">
              <el-row>
                <el-col :span="24" style="margin-bottom: 5px;">
                  <label><el-checkbox v-model="setForm.rndGroup">随机获取群</el-checkbox></label>
                </el-col>
                <el-col :span="24" style="margin-bottom: 5px;">
                  <label><el-checkbox v-model="setForm.curstGroup">指定群编号</el-checkbox></label>
                  <el-input v-model="setForm.curstGroup_edt" clearable style="margin-left: 10px;width: 30%"></el-input>
                </el-col>
              </el-row>
            </el-card>

            <el-card class="box-card" style="margin-bottom: 15px">
<!--              <el-row type="flex">-->
              <el-row >
<!--                <el-col :span="24" style="margin-bottom: 5px;">-->
<!--                  <el-checkbox v-model="setForm.isBZ">加好友时自动备注</el-checkbox>-->
<!--                </el-col>-->
<!--                <el-col :span="24" style="margin-bottom: 5px;">-->
<!--                    <label><el-checkbox v-model="setForm.chk_biaoshi">备注标记:</el-checkbox></label>-->
<!--                  <el-input v-model="setForm.edt_biaoshi" clearable style="margin-left: 10px;width: 30%"></el-input>-->
<!--                </el-col>-->

              </el-row>

              <el-form-item label="任务轮次" prop="taskCount" style="margin-bottom: 3px;">
                <el-input v-model="setForm.taskCount" clearable></el-input>
              </el-form-item>
              <el-form-item label="每轮等待" prop="taskWait" style="margin-bottom: 3px;">
                <el-input v-model="setForm.taskWait" placeholder="秒,每轮任务完成后等待" clearable></el-input>
              </el-form-item>
              <el-form-item label="启动等待" prop="startWait" style="margin-bottom: 3px;">
                <el-input v-model="setForm.startWait" placeholder="秒" clearable></el-input>
              </el-form-item>
              <el-form-item label="网络超时" prop="netWait" style="margin-bottom: 3px;">
                <el-input v-model="setForm.netWait" placeholder="秒" clearable></el-input>
              </el-form-item>
              <el-form-item label="取通讯录" prop="getPhoneCount" style="margin-bottom: 3px;">
                <el-input v-model="setForm.getPhoneCount" placeholder="每个账号每次取通讯录数" clearable></el-input>
              </el-form-item>
              <el-form-item label="加人间隔" prop="addWait" style="margin-bottom: 3px;">
                <el-input v-model="setForm.addWait" placeholder="秒,支持5-10之间随机数值" clearable></el-input>
              </el-form-item>
              <el-form-item label="单号加人" prop="addCount" style="margin-bottom: 3px;">
                <el-input v-model="setForm.addCount" placeholder="满足条件后自动切换账号" clearable></el-input>
              </el-form-item>
              <el-form-item label="任务超时" prop="taskOut" style="margin-bottom: 3px">
                <el-input v-model="setForm.taskOut" placeholder="分,超出时间自动切换账号" clearable></el-input>
              </el-form-item>

              <el-row>
                <el-form-item label="登录密码" prop="accountPwd" style="margin-bottom: 3px;">
                  <el-input v-model="setForm.accountPwd" placeholder="钉钉的密码,掉号自动登录, ##分割符,支持多个密码,顺序提取" clearable ></el-input>
                </el-form-item>
<!--                    <el-form-item label="删除好友" prop="delFriends" style="margin-bottom: 3px;">-->
<!--                      <el-input v-model="setForm.delFriends" placeholder="删除此日期以前的好友,例:0501 填入0删除全部好友" clearable ></el-input>-->
<!--                    </el-form-item>-->
                <el-form-item label="修改名字" prop="nick" style="margin-bottom: 3px;margin-top: 10px">
                  <el-input v-model="setForm.nick" placeholder="##分隔随机抽取。 支持随机名字:变量:%姓% %名%" clearable></el-input>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item label="验证消息" prop="yzMsg" style="margin-bottom: 3px;margin-top: 10px">
                  <el-input v-model="setForm.yzMsg" placeholder="##分隔随机抽取。 支持变量:%姓名%" clearable></el-input>
                </el-form-item>
              </el-row>

<!--                  <el-row type="flex">-->
<!--                  <el-form-item label="在线状态" prop="online" style="margin-bottom: 3px;">-->
<!--                    <el-radio-group v-model="setForm.online" size="mini">-->
<!--                      <el-col :span="8"><el-radio-button border label="在线"></el-radio-button></el-col>-->
<!--                      <el-col :span="8"><el-radio-button border label="隐身"></el-radio-button></el-col>-->
<!--                      <el-col :span="8"><el-radio-button border label="忙碌"></el-radio-button></el-col>-->
<!--                    </el-radio-group>-->
<!--                  </el-form-item>-->
<!--                  </el-row>-->
<!--                  <el-row>-->
<!--                    <el-form-item label="Q Q 密码" prop="QQpwd" style="margin-bottom: 3px;">-->
<!--                      <el-input v-model="setForm.QQpwd" placeholder="自动登录QQ必须" clearable></el-input>-->
<!--                    </el-form-item>-->
<!--                  </el-row>-->
<!--                  <el-form-item label="图灵账号" prop="tlUser" style="margin-bottom: 3px;">-->
<!--                    <el-input v-model="setForm.tlUser" placeholder="滑块打码必须" clearable></el-input>-->
<!--                  </el-form-item>-->
<!--                  <el-form-item label="图灵密码" prop="tlPwd" style="margin-bottom: 3px;">-->
<!--                    <el-input v-model="setForm.tlPwd" placeholder="滑块打码必须" clearable></el-input>-->
<!--                  </el-form-item>-->



            </el-card>

<!--            <el-divider content-position="left">其他设置</el-divider>-->

  <!--          <el-form ref="form_script" :model="setForm" label-width="80px">-->

  <!--          </el-form>-->
            <div>
              <el-divider content-position="left">帮助说明</el-divider>
              <el-tag type="success">执行任务: 可以多选任务,脚本会按顺序执行</el-tag>
              <el-tag type="success">任务轮次: 1轮= 1x账号数量</el-tag>
              <el-tag type="success">网络超时: 根据你的网络状况是否良好设置</el-tag>
              <el-tag type="success">任务超时: 每个任务最大的运行时间,超出后切换到下一个</el-tag>


<!--              <el-tag type="info">QQ密码: 掉号时自动登录需要,支持设置多个密码 &#45;&#45;&#45;&#45;符号分割</el-tag>-->
<!--              <el-tag type="info">图灵账户: 自动登录时打码,滑块需要</el-tag>-->
<!--              <el-tag type="info">图灵网址: fdyscloud.com.cn 请到这里自行注册充值</el-tag>-->

            </div>

          </el-tab-pane>





        </el-tabs>

      </el-form>

    </el-card>


  </el-row>
</template>

<script>


export default {
  data(){
    return {
      userName : window.sessionStorage.getItem('account'),
      configOptions: [{
        value: '配置1',
      },{
        value: '配置2',
      },{
        value: '配置3',
      },{
        value: '配置4',
      },{
        value: '配置5',
      },{
        value: '配置6',
        label: '配置6'
      },{
        value: '配置7',
        label: '配置7'
      },{
        value: '配置8',
        label: '配置8'
      },{
        value: '配置9',
        label: '配置9'
      },{
        value: '配置10',
        label: '配置10'
      }],
      activeName: 'tab_main',
      taskList: [{
        value: '添加好友',
        label: '添加好友'
      }, {
        value: '修改资料',
        label: '修改资料'
      }, {
        value: '统计好友',
        label: '统计好友'
      }, {
        value: '删除好友',
        label: '删除好友'
      }, {
        value: '自动拉群',
        label: '自动拉群'
      }, {
        value: '自动补群',
        label: '自动补群'
      }, {
        value: '删除已拉',
        label: '删除已拉'
      }, {
        value: '进入群聊',
        label: '进入群聊'
      }, {
        value: '退出群聊',
        label: '退出群聊'
      }, {
        value: '排序列表',
        label: '排序列表'
      }, {
        value: '备份VS列表',
        label: '备份VS列表'
      }, {
        value: '还原VS列表',
        label: '还原VS列表'
      }],

      configArr:[],
      setForm: {
        phoneType:"小米6",
        loginType:"VS助手",
        chatMsg:'',
        configLab: '配置1',
        accountPwd:'qq100200##qwe123123',
        nick:'%姓%%名%',
        yzMsg:'%姓名%你好啊##%姓名%你好,通过一下',
        delFriends:"0",
        //vs
        vsList:[],
        VSidx:'',
        vs_hjRest:false,
        vs_ignoreErrorHJ:true,
        vs_airSwift:true,
        vs_delHJ:true,
        vs_updateHJ:false,
        vs_updateHJerr:false,
        vs_findLab:false,

        //main
        taskCount:'1',
        online: '在线',
        netWait:'10',
        taskWait:'10',
        taskOut:"30",
        task:[],
        getPhoneCount:"3",
        startWait:"5",
        addWait:"5-10",
        addCount:"6",
        useData:"aa",
        isBZ:true,
        rndGroup:false,
        curstGroup:false,
        curstGroup_edt:'1',
        addType_tele:true,
        addType_search:false,
        fs_idxS:"",
        fs_idxE:"",

      },
      fs_list:[],
      fs_list2:[],

      rules: {
        name: [
          { type: 'Number',required: true, message: '请输入生成数量', trigger: 'blur'},
          {min: 1, max: 3, message: '长度在 1 到 3 个字符', trigger: 'blur'}
        ],
      },

      machineLog:'',
      timeoutId:null,
      fullscreenLoading:false,
      show_vs:false,
      show_fs:false,
      show_group:true

    }
  },
  watch: {

    'setForm.loginType'(newValue, oldValue) {
      this._showVS(newValue);
    },
  },
  created() {
    // this.loadDefault();
    // this._showVS();

  },
  beforeDestroy() {

  },
  mounted() {
    this.getDefaultConfig();
    this._showVS(this.setForm.loginType);
  },
  methods:{
    _showVS(value){
      if (value === "无"){
        this.show_vs = false;
        this.show_fs = false;
      }else if (value === "VS助手"){
        this.show_vs = true;
        this.show_fs = false;
      }else if (value === "分身"){
        this.show_vs = false;
        this.show_fs = true;

        this.fs_list = [{value:0,label:"钉钉"}];
        let json =  {};
        for (let i = 1; i < 100; i++) {
          json = {};
          json.value = i
          json.label = '钉钉'+i.toString();
          this.fs_list.push(json);
        }
        this.fs_list2 = [{value:0,label:"钉钉"}];
        for (let i = 1; i < 100; i++) {
          json = {};
          json.value = i
          json.label = '钉钉'+i.toString();
          this.fs_list2.push(json);
        }
      }
    },
    handleClick(tab, event) {
      console.log(tab.name, event);
    },
    selTask(value){
      console.log(value);
    },
    // loadDefault(){
    //   this.getDefaultConfig();
    //   clearTimeout(this.timeoutId);
    //   this.timeoutId = setTimeout(() => {
    //     this.selConfigLab('配置1');
    //     this.fullscreenLoading = false;
    //   }, 1500);
    // },


    //读取配置
    selConfigLab(value) {
      console.log(value);
      if (this.configArr){
        let json = JSON.parse(this.configArr);
        if(json){
          for (const k in json) {
            if(value === json[k].lab){
              console.log("读取"+json[k].lab,json[k].config);
              this.setForm   = JSON.parse(json[k].config);
              return
            }
          }
        }
      }
      this.setForm.task = [];
    },

    async post_setScript() {
      if (!this.userName) {
        this.$msgNot.error('登录状态异常,请重新登录');
        return;
      }
      console.log(JSON.stringify(this.setForm));
      if (this.setForm.configLab === ""){
        this.$msgNot.error('请选择模板');
        return;
      }

      this.$refs['form_script'].validate(async (valid) => {
        if (valid) {
          // const obj = Object.assign(this.setForm, this.mainForm, this.addForm,this.editForm);
          const {data: res} = await this.$ajax.post("/api/config/setConfig", {'account': this.userName, 'data':this.setForm});
          if (res.code === 200) {
            this.$msgNot.success(res.msg);
            this.showSetScript = false;
            // await this.getDefaultConfig();
          } else {
            this.$msgNot.error(res.msg);
          }

        } else {
          console.log('error postForm!!');
          return false;
        }
      });

    },
    async getDefaultConfig() {
      if (!this.userName) {
        this.$msgNot.error('登录状态异常,请重新登录');
        return;
      }

      const {data: res} = await this.$ajax.post("/api/config/getConfig", {'account': this.userName});
      if (res.code === 200) {
        // this.$msgNot.success(res.msg);
        this.configArr = res.data;
        this.selConfigLab('配置1');
      } else {
        this.$msgNot.error(res.msg);
      }
    }

  },
}
</script>

<style scoped>
.el-ta {
  /*background-color: #222D32;*/
  color: #000000;
  text-align: left;
  /*line-height: 150px;*/
  margin: 1px;
  padding: 1px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.el-tag{
  margin-left: 5px;
}
.el-switch{
  margin-left: 10px;
}

</style>
